const highchartsThemeDefault: Record<string, unknown> = {
  credits: false,
  colors: ['#026adf', '#4c96e8', '#7fb4ef', '#5b98ff', '#92e1fa'],
  chart: {
    style: {
      fontFamily: 'Inter',
    },
    backgroundColor: 'transparent',
    height: 'inherit',
  },
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    noData: 'Keine Daten vorhanden.'
  },
  title: {
    text: '',
    align: 'center',
    style: {
      font: '18px Inter',
      fontWeight: '350',
      color: 'black'
    }
  },
  subtitle: {
    text: '',
    style: {
      font: '14px Inter',
      color: 'black'
    }
  },
  tooltip: {
    backgroundColor: "rgba(255,255,255,1)",
    outside: true,
    borderRadius: 5,
  },
  legend: {
    title: {
      style: {
        fontFamily: 'Inter'
      }
    },
    itemStyle: {
      font: '13px Inter',
      lineHeight: '26px',
      color: '#555'
    },
    itemHoverStyle: {
      color: 'black'
    }
  },
  plotOptions: {
    series: {
      dataLabels: {
        style: {
          fontFamily: 'Inter',
          fontSize: '13px',
          textOutline: false,
          fontWeight: 'light'
        }
      }
    }
  },
  xAxis: {
    visible: true,
    lineWidth: 0,
    labels: {
      style: {
        fontSize: '13px',
        font: '13px Inter'
      },
    },
    title: {
      style: {
        fontSize: '13px',
        font: '13px Inter'
      }
    }
  },
  yAxis: {
    visible: false,
    lineWidth: 0,
    labels: {
      style: {
        fontSize: '13px',
        font: '13px Inter'
      }
    },
    title: {
      style: {
        fontSize: '20px',
        font: '13px Inter'
      }
    }
  },
  noData: {
    position: {
        align: 'center', 
        verticalAlign: 'middle', 
        x: 0,
        y: 0
    },
    style: {
        fontWeight: 'bold',
        fontSize: '20px',
        color: '#aaa' 
    }
  }
}

export { highchartsThemeDefault }
